import React from 'react';
import styled from 'styled-components';

// "Responding to" the prompt a post or list answers, at the top of its
// composer. Shared by the post and list composers so both read the same.
// Without onRemove the prompt is shown but cannot be taken off (a published
// list's prompt is locked).

const Banner = styled.div`
  position: relative;
  background: #f9f9f9;
  border-left: 3px solid black;
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  border-radius: 0 8px 8px 0;
`;

const Label = styled.div`
  font-size: 0.72rem;
  color: #888;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0.25rem;
`;

const Text = styled.div`
  font-size: 0.9rem;
  font-weight: 700;
  color: #111;
  line-height: 1.4;
`;

const RemoveButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  color: #999;
  line-height: 1;
  padding: 0;
`;

interface PromptResponseBannerProps {
  text: string;
  onRemove?: () => void;
}

export default function PromptResponseBanner(props: PromptResponseBannerProps) {
  return (
    <Banner>
      <Label>Responding to</Label>
      <Text>{props.text}</Text>
      {props.onRemove && (
        <RemoveButton type="button" onClick={props.onRemove} aria-label="Remove prompt">
          &times;
        </RemoveButton>
      )}
    </Banner>
  );
}
